import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=58fe1a78"
import script from "./AddCategory.vue?vue&type=script&lang=js"
export * from "./AddCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports